import { formatTIN, formatBRN } from '../helper';

function validateTIN(tin) {
    if (!tin) return false;
    const tinRegex = /^[A-Z0-9]{10,15}$/;
    return tinRegex.test(formatTIN(tin));
}

function validateMSIC(code) {
    if (!code) return false;
    const msicRegex = /^[0-9]{5}$/;
    return msicRegex.test(code);
}

function validateAmount(amount) {
    if (amount === null || amount === undefined) return false;
    return !isNaN(parseFloat(amount)) && parseFloat(amount) >= 0;
}

function validatePhoneNumber(number) {
    if (!number) return false;
    const phoneRegex = /^(\+?60|0)?1[0-46-9][0-9]{7,8}$/;
    return phoneRegex.test(number.replace(/\D/g, ''));
}

function validateEmail(email) {
    if (!email) return false;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

function validateBRN(brn) {
    if (!brn) return false;
    const brnRegex = /^[A-Z0-9]{1,12}$/;
    return brnRegex.test(formatBRN(brn));
}

function validateInvoiceId(id) {
    if (!id) return false;
    const invoiceIdRegex = /^[A-Z0-9-]{1,50}$/i;
    return invoiceIdRegex.test(id);
}

export {
    validateTIN,
    validateBRN,
    validateMSIC,
    validateAmount,
    validatePhoneNumber,
    validateEmail,
    validateInvoiceId
};
